// extracted by css-extract-rspack-plugin
export default {"container":"ResolvedPlanStatus-module__container__mHTL5"};